import _ from 'lodash';
import { useEffect } from 'react';
import { showMessage } from '~/helper';
import { format } from 'date-fns';
import api from '~/services/api';
import useGlobalContext from '~/view-data/use-global-context';
import useFetch from '~/view-data/use-fetch';
import useHeader from '~/view-data/use-header';

const initialState = {
  loading: false,
  formOpen: false,
  formLoading: false,
  fromGroup: false,
  isPress: false,
  term: null,
  offset: 0,
  model: null,
  showImportModal: false,
  modalData: {},
  data: { rows: [], count: 0, offset: 0 },
};

const usePersons = () => {
  const { state: { persons = initialState }, dispatch } = useGlobalContext(),
    { actions: headerActions } = useHeader();

  const { data, mutate } = useFetch({
    url: 'persons/list',
    params: { term: persons.term, offset: persons.offset },
  });

  useEffect(() => {
    headerActions.configure({
      title: 'Colaboradores',
      count: _.get(data, 'count', 0),
      loading: _.get(persons, 'loading', false),
      onSearch: (text) => list(0, text),
    });
    // eslint-disable-next-line
  }, [data, persons]);

  const list = (offset = 0, term) => {
    dispatch({ type: 'persons', payload: { offset, term } });
  };

  const pageChange = (offset = 0) => {
    dispatch({ type: 'persons', payload: { offset } });
  };

  const load = async (data = {}) => {
    try {
      dispatch({ type: 'persons', payload: { model: {}, formLoading: true, formOpen: true } });
      let model = { active: true };

      const response = await api.get('persons/load', { params: { id: data.id } });
      model = _.get(response.data, 'data');
      let fromGroup = _.get(response.data, 'fromGroup');
      let isPress = _.get(response.data, 'isPress');

      dispatch({ type: 'persons', payload: { model, fromGroup, isPress, formLoading: false } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const formClose = () => {
    dispatch({ type: 'persons', payload: { formOpen: false } });
  };

  const createOrUpdate = async (model, actions) => {
    dispatch({ type: 'persons', payload: { formLoading: true } });

    try {
      let editing = !!(model && model.id),
        method = editing ? 'put' : 'post',
        path = editing ? 'update' : 'create';

      await api[method](`persons/${path}`, model);
      mutate(data);

      showMessage('success', `Colaborador ${editing ? 'atualizado' : 'criado'} com sucesso`);
      actions.toogleForm && actions.toogleForm();
    dispatch({ type: 'persons', payload: { formLoading: false, formOpen: false } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const exportSpreadsheetErrors = async (data) => {
    dispatch({ type: 'persons', payload: { loading: true } });

    try {
      let response = await api.post(`persons/export-errors-xlsx`, { data }, { responseType: 'blob' }),
        filename = `colaboradores-errors-${format(new Date(), 'dd-MM-yyyy-HH-mm')}.xlsx`;
      api.download(response, filename);

      dispatch({ type: 'persons', payload: { loading: false } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const exportSpreadsheet = async () => {
    dispatch({ type: 'persons', payload: { loading: true } });

    try {
      let response = await api.get(`persons/export-xlsx`, { responseType: 'blob' }),
        filename = `colaboradores-${format(new Date(), 'dd-MM-yyyy-HH-mm')}.xlsx`;
      api.download(response, filename);

      dispatch({ type: 'persons', payload: { loading: false } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const importSpreadsheet = async (files) => {
    let file = _.first(files);
    if (!file) {
      return;
    }
    dispatch({ type: 'persons', payload: { loading: true } });
    try {
      let params = new FormData();
      params.append('file', file);
      let response = await api.post(`persons/import-xlsx`, params);
      dispatch({ type: 'persons', payload: { loading: false, modalData: response.data, showImportModal: true }});
      mutate(data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const listRoles = async (term, callback) => {
    try {
      const response = await api.get(`persons/list-roles`, { params: { term } });
      callback(response.data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const closeImportModal = () => {
    dispatch({ type: 'persons', payload: { modalData: {}, showImportModal: false }});
  };

  const saveImportModal = async (params) => {
    try {
      dispatch({ type: 'persons', payload: { modalLoading: true } });
      await api.post(`persons/import-data`, params);
      mutate(data);
      dispatch({ type: 'persons', payload: { modalLoading: false, modalData: {}, showImportModal: false } });
      showMessage('success', `Colaboradores importados com sucesso!`);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  return {
    state: {
      ...persons,
      data: data || {},
      loading: !data,
    },
    actions: {
      pageChange,
      load,
      list,
      createOrUpdate,
      exportSpreadsheetErrors,
      exportSpreadsheet,
      importSpreadsheet,
      listRoles,
      formClose,
      closeImportModal,
      saveImportModal,
    },
  };
};

const failure = (error, dispatch) => {
  dispatch({ type: 'persons', payload: { loading: false, formLoading: false } });
  showMessage('error', error);
};

export default usePersons;
